import React from 'react';
import './footer.css';

const Footer = () => {

  return (

    <footer className="footer">

      <div className="footer-container">

        <div className="footer-top">

          <div className="footer-brand">

            <div className="footer-logo">
              منصوري تكس
            </div>

            <div className="footer-desc">
              فخامة وجودة بأسعار تنافسية
            </div>

          </div>

          <div className="footer-links">

            <a href="/">الرئيسية</a>

            <a href="/ContactUs/ContactUs">
              تواصل معنا
            </a>

            <a href="/Shoping/items">
              المنتجات
            </a>

          </div>

        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">

          <div className="footer-copy">

            Copyright © 2026
            {' '}
            <span>Mansoory Textile</span>

          </div>

          <div className="footer-version">

            ERP System v2.0

          </div>

        </div>

      </div>

    </footer>

  );

};

export default Footer;